// extracted by mini-css-extract-plugin
module.exports = {"svgContainer":"_3Ro9YREE5pR96gg0TFtJD1"};